

interface EmptyDataProps {
  colSpan: number;
}

export const EmptyData: React.FC<EmptyDataProps> = ({ colSpan }) => (
  <tbody>
    <tr>
      <td
        colSpan={colSpan}
        style={{
          textAlign: 'center',
          padding: '2rem',
          color: 'rgba(100, 99, 99, 1)',
          backgroundColor: 'rgba(156, 156, 156, 0.1)',
        }}
      >
        Não há dados para serem exibidos
      </td>
    </tr>
  </tbody>
);